import * as React from 'react';

var AlertContent = function AlertContent(_ref) {
  var children = _ref.children,
      getBodySlot = _ref.getBodySlot;
  var bodyCb = React.useCallback(function (node) {
    getBodySlot && getBodySlot(node);
  }, [getBodySlot]);
  return /*#__PURE__*/React.createElement("div", {
    ref: bodyCb
  }, children);
};

export default AlertContent;

try {
  AlertContent.__docgenInfo = {
    description: '',
    displayName: 'AlertContent',
    methods: [],
    props: {
      getBodySlot: {
        defaultValue: null,
        description: '',
        name: 'getBodySlot',
        required: false,
        type: {
          name: '(elem: HTMLElement) => any'
        }
      }
    }
  };
} catch (e) {}
//# sourceMappingURL=index.js.map